import styled from '@emotion/styled';
import { rem } from 'polished';
import { qantasHotels as qantasHotelsLogo } from '@qga/roo-ui/logos';

const Logo = styled.img`
  display: inline-flex;
  width: ${rem('150px')};
`;

Logo.displayName = 'Logo';

const QantasHotelsLogo = () => <Logo src={qantasHotelsLogo} alt="Qantas Hotels" role="img" aria-label="Qantas Hotels Logo" />;

export default QantasHotelsLogo;
